import {
  GET_LIST_CHECKTHONGTINKH,
  GET_LIST_CHECKTHONGTINKH_SUCCESS,
  GET_LIST_CHECKTHONGTINKH_FAILURE,
} from "actions/CheckThongTinKh/actionTypes";

const initialState = {
  getListCheckThongTinKhLoading: false,
  posts: [],
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
  totalRow: 0,
};

const getListCheckThongTinKh = (state, action) => ({
  ...state,
  getListCheckThongTinKhLoading: true,
});

const getListCheckThongTinKhSuccess = (state, action) => {
  return {
    ...state,
    getListCheckThongTinKhLoading: false,
    objList: action.payload,
  };
};

const getListCheckThongTinKhFailed = (state, action) => ({
  ...state,
  getListCheckThongTinKhLoading: false,
  objList: {
    List: [],
    TotalMoney: 0,
    TotalPaid: 0,
    TotalPaidToDateNow: 0,
    TotalQuantity: 0,
  },
});

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_CHECKTHONGTINKH:
      return getListCheckThongTinKh(state, action);
    case GET_LIST_CHECKTHONGTINKH_SUCCESS:
      return getListCheckThongTinKhSuccess(state, action);
    case GET_LIST_CHECKTHONGTINKH_FAILURE:
      return getListCheckThongTinKhFailed(state, action);
    default:
      return state;
  }
};

export default authReducer;
